module.exports = __webpack_public_path__ + "static/media/jfCode.e5170c8d.jpg";